export default __webpack_public_path__ + "static/media/mic_on.4afaa6e2.png";